"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSizeme = _interopRequireDefault(require("react-sizeme"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactRedux = require("react-redux");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var cacheWidth = 100;
var ProgressBar = function ProgressBar(props) {
  var playerSettings = props.playerSettings,
    progressBarPercent = props.progressBarPercent,
    segmentedProgressBar = props.segmentedProgressBar,
    goToComponent = props.goToComponent,
    size = props.size;
  var width = size.width || cacheWidth;
  cacheWidth = width;
  var isPresenterMode = (0, _reactRedux.useSelector)(function (state) {
    return state.flow.player.isPresenterMode;
  });

  // we need transform for iOS bug fix
  var simpleBar = /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress",
    style: {
      margin: '0px',
      transform: 'rotate(0.02deg)'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress-bar progress-bar-primary",
    style: {
      width: progressBarPercent + '%'
    }
  }));
  if (playerSettings.useSegmentedProgressBar) {
    if (width < 600) {
      var content = /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].segmentedList
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group-vertical"
      }, segmentedProgressBar.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: item.id,
          type: "button",
          className: (0, _classnames2["default"])('btn btn-default', {
            'btn-primary': item.isCurrent || item.progress === 'past',
            active: item.isCurrent
          }),
          style: {
            whiteSpace: 'normal'
          },
          disabled: item.progress === 'future'
        }, item.progress === 'past' ? {
          onClick: function onClick() {
            return goToComponent(item.id);
          }
        } : {}), item.tooltip);
      })));
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: content,
        maxWidth: "100vw",
        tippyProps: {
          theme: 'light',
          interactive: true,
          appendTo: document.body
        }
      }, simpleBar);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].segmentedProgressBar
    }, segmentedProgressBar.map(function (item) {
      var _classnames;
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        key: item.id,
        className: (0, _classnames2["default"])(_style["default"].item, (_classnames = {}, _defineProperty(_classnames, _style["default"].past, item.progress === 'past' || isPresenterMode), _defineProperty(_classnames, _style["default"].isCurrent, item.isCurrent), _classnames)),
        style: {
          width: item.width,
          minWidth: '5px'
        }
      }, item.progress === 'past' || isPresenterMode ? {
        onClick: function onClick() {
          return goToComponent(item.id);
        }
      } : {}), item.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        key: item.id,
        title: item.tooltip,
        tippyProps: {
          hideOnClick: false,
          appendTo: 'parent'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tooltipTrigger
      })) : null);
    }));
  }
  return simpleBar;
};
var _default = (0, _reactSizeme["default"])({
  refreshRate: 100,
  noPlaceholder: true
})(ProgressBar);
exports["default"] = _default;